import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

const CARD_W = 205;
const CARD_GAP = 15;
const ROW_2_OFFSET = (CARD_W + CARD_GAP) / 2;

domReady(() => {
  document.querySelectorAll('.partners__row.swiper').forEach((el) => {
    const initialSlide = Number(el.dataset.realSlides) || 0;

    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: CARD_GAP,
      grabCursor: true,
      watchOverflow: true,
      initialSlide,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: el.closest('.partners').querySelector('.vtx-swiper__next'),
        prevEl: el.closest('.partners').querySelector('.vtx-swiper__prev'),
      },
      breakpoints: {
        768: {
          freeMode: {
            enabled: true,
            momentum: true,
          },
        },
      },
      a11y: {
        enabled: true,
        scrollOnFocus: true,
        prevSlideMessage: _x(
          'Go to previous slide',
          'swiper accessibility',
          'vtx'
        ),
        nextSlideMessage: _x('Go to next slide', 'swiper accessibility', 'vtx'),
        slideLabelMessage: _x(
          'Slide {{index}} of {{slidesLength}}',
          'swiper accessibility',
          'vtx'
        ),
      },
    });

    if (el.classList.contains('partners__row--2')) {
      swiper.setTranslate(swiper.translate - ROW_2_OFFSET);
    }
  });
});
